import Vue from 'vue'
import Vuex from 'vuex'
import appData from './modules/app-data'
import account from './modules/account'
import dashBoard from './modules/dashboard'
Vue.use(Vuex)

const state = {
  showPersonalMenu: false,
  dialogData: null,
  errorData: null,
  toastMessage: null,
  headerHeight: 52
}

const mutations = {
  setShowPersonalMenu (state, value) {
    state.showPersonalMenu = value
  },
  setDialogData (state, value) {
    state.dialogData = value
  },
  setErrorData (state, value) {
    state.errorData = value
  },
  setToastMessage (state, value) {
    state.toastMessage = value
  },
  setHeaderHeight (state, value) {
    state.headerHeight = value
  }
}

const actions = {

}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    appData,
    account,
    dashBoard
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js